import React from 'react';

const CaseStudiesPage = ({ onClose, onSelectCaseStudy }) => {
  const caseStudies = [
    {
      id: 'blinkit',
      title: 'Blinkit',
      subtitle: 'Engagement & Retention Report',
      description: 'Comprehensive analysis of Blinkit\'s quick-commerce strategy, user segmentation, and retention campaigns.',
      tags: ['Quick Commerce', 'Retention', 'Engagement']
    },
    {
      id: 'rapido',
      title: 'Rapido',
      subtitle: 'Recurring Rides Feature',
      description: 'Product design for commuter reliability through recurring ride subscriptions and predictable demand.',
      tags: ['Mobility', 'Product Design', 'B2C']
    }
  ];

  return (
    <div 
      className="h-screen w-screen bg-[#111111] text-white overflow-y-auto overflow-x-hidden"
      style={{ fontFamily: "'FFF Acid Grotesk', sans-serif" }}
    >
      {/* Header */}
      <div className="sticky top-0 z-50 bg-[#111111] border-b border-gray-800 px-8 py-6">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <h1 className="text-3xl font-bold">Case Studies</h1>
          <button
            onClick={onClose}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClose();
              }
            }}
            className="px-6 py-2 bg-[#3a3a3a] hover:bg-[#4a4a4a] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white text-sm tracking-wider"
            tabIndex={0}
            aria-label="Back to landing"
          >
            ← BACK
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-6xl mx-auto px-8 py-16">
        <div className="mb-12">
          <p className="text-xl text-gray-400 leading-relaxed">
            Explore detailed product and growth case studies showcasing strategic thinking, 
            user research, and data-driven decision making.
          </p>
        </div>

        {/* Case Studies Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {caseStudies.map((study) => (
            <button
              key={study.id}
              onClick={() => onSelectCaseStudy(study.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelectCaseStudy(study.id);
                }
              }}
              className="group bg-[#1a1a1a] border border-gray-800 hover:border-gray-600 transition-all duration-300 p-8 text-left focus:outline-none focus:ring-2 focus:ring-white"
              tabIndex={0}
              style={{ boxShadow: 'none' }}
            >
              {/* Title */}
              <h2 className="text-3xl font-bold mb-2 group-hover:text-blue-400 transition-colors">
                {study.title}
              </h2>
              
              {/* Subtitle */}
              <p className="text-lg text-gray-400 mb-4">
                {study.subtitle}
              </p>

              {/* Description */}
              <p className="text-base text-gray-300 leading-relaxed mb-6">
                {study.description}
              </p>

              {/* Tags */}
              <div className="flex flex-wrap gap-2">
                {study.tags.map((tag, index) => (
                  <span
                    key={index}
                    className="px-3 py-1 bg-[#2a2a2a] text-gray-400 text-xs tracking-wider border border-gray-700"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              {/* Arrow indicator */}
              <div className="mt-6 flex items-center text-gray-500 group-hover:text-blue-400 transition-colors">
                <span className="text-sm tracking-wider">READ CASE STUDY</span>
                <svg 
                  className="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="border-t border-gray-800 px-8 py-6 mt-16">
        <div className="max-w-6xl mx-auto text-center text-sm text-gray-500">
          <p>Product & Growth Case Studies</p>
        </div>
      </div>
    </div>
  );
};

export default CaseStudiesPage;
